import { TwilioDeviceStatus } from '../constants/TwilioDeviceStatus';
export const getCallStatus = widgetDetails => widgetDetails.callStatus;
export const getActiveCallDetails = widgetDetails => widgetDetails.activeCallDetails;
export const getDeviceError = widgetDetails => widgetDetails.deviceErrorCode;
export const getStartCallError = widgetDetails => widgetDetails.startCallError;
export const getMicrophoneDeviceId = widgetDetails => widgetDetails.microphoneDeviceId;
export const getSpeakerDeviceId = widgetDetails => widgetDetails.speakerDeviceId;
export const getCallSettings = widgetDetails => {
  return {
    connectFromNumbers: widgetDetails.connectFromNumbers,
    externalFromNumbers: widgetDetails.externalFromNumbers,
    portalFromNumbers: widgetDetails.portalFromNumbers,
    hasCallingAccess: widgetDetails.hasCallingAccess,
    isHubSpotCallingEnabled: widgetDetails.isHubSpotCallingEnabled,
    isRecordingEnabled: widgetDetails.isRecordingEnabled,
    isPaidHub: widgetDetails.isPaidHub,
    callReceivingPreference: widgetDetails.callReceivingPreference,
    callingLimit: widgetDetails.callingLimit,
    callDispositions: widgetDetails.callDispositions,
    callTypes: widgetDetails.callTypes,
    defaultTaskSettings: widgetDetails.defaultTaskSettings
  };
};
export const getStandaloneConnectionId = widgetDetails => widgetDetails.standaloneConnectionId;
export const getCriticalFailureReason = widgetDetails => widgetDetails.criticalFailureReason;
export const getCallsV1SettingsUsage = widgetDetails => widgetDetails.callsV1SettingsUsage;
export const getSelectedFromNumber = widgetDetails => widgetDetails.selectedFromNumber;
export const getTransferInformation = widgetDetails => widgetDetails && widgetDetails.transferInformation;
export const getTwilioDeviceStatus = widgetDetails => widgetDetails && widgetDetails.twilioDeviceStatus;
export const isTwilioDeviceRegistering = widgetDetails => Boolean(widgetDetails && getTwilioDeviceStatus(widgetDetails) === TwilioDeviceStatus.REGISTERING);
export const isTwilioDeviceUnregistered = widgetDetails => Boolean(widgetDetails && getTwilioDeviceStatus(widgetDetails) === TwilioDeviceStatus.UNREGISTERED);
export const getPortalFromNumbers = widgetDetails => widgetDetails.portalFromNumbers;
export const getExternalFromNumbers = widgetDetails => widgetDetails.externalFromNumbers;
export const getConnectFromNumbers = widgetDetails => widgetDetails.connectFromNumbers;